import { render, staticRenderFns } from "./ResearchHome.vue?vue&type=template&id=1943b65a"
import script from "./ResearchHome.vue?vue&type=script&lang=js"
export * from "./ResearchHome.vue?vue&type=script&lang=js"
import style0 from "./ResearchHome.vue?vue&type=style&index=0&id=1943b65a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1943b65a')) {
      api.createRecord('1943b65a', component.options)
    } else {
      api.reload('1943b65a', component.options)
    }
    module.hot.accept("./ResearchHome.vue?vue&type=template&id=1943b65a", function () {
      api.rerender('1943b65a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/research/ResearchHome.vue"
export default component.exports